<div class="d-flex" style="border-bottom: 1px solid #00ffff; justify-content: space-between;">
  <label style="width: 50%; margin-top: 0px; border: none" for="address">{{ 'VENUES.PHOTO_GALLERY' | translate | uppercase }}</label>
</div>
<div class="gallery-container d-flex flex-row">
  <div *ngFor="let image of imagesServerData; let i = index" class="gallery-item">
    <!-- <div (click)="openAddImage(i)" *ngIf="!imagesServerData[i].url">
      {{ 'VENUES.ADD_NEW' | translate }} <span>+</span>
    </div> -->
    <div (click)="cropAndCompressImageDialog(i)" *ngIf="!imagesServerData[i].url">
      {{ 'VENUES.ADD_NEW' | translate }} <span>+</span>
    </div>
    <!-- <input
      (change)="onFileSelected($event, i)"
      style="display: none;"
      type="file"
      id="openPhoto-{{i}}"
      #openFile
      name="openPhoto-{{i}}"
      accept="image/png, image/jpg, image/jpeg"
    /> -->
    <!-- <input
      (change)="cropAndCompressImageDialog()"
      style="display: none;"
      type="file"
      id="openPhoto-{{i}}"
      #openFile
      name="openPhoto-{{i}}"
      accept="image/png, image/jpg, image/jpeg"
    /> -->
    <img id="image-{{i}}" *ngIf="imagesServerData[i].url" [src]="imagesServerData[i].url?imagesServerData[i].url: './assets/images/icons/profile-picture-placeholder-01.svg'" alt="placeholeder">
    <div *ngIf="imagesServerData[i].url" class="actions d-flex">
      <!-- <mat-icon (click)="openAddImage(i)">edit</mat-icon><mat-icon (click)="removeImage(i)">delete</mat-icon> -->
      <mat-icon (click)="cropAndCompressImageDialog(i)">edit</mat-icon><mat-icon (click)="removeImage(i)">delete</mat-icon>
    </div>
  </div>
  <!-- <label class="pictureError"  *ngIf="pictureIsToBig">{{ 'VENUES.PICTURE_IS_TO_BIG' | translate }}</label> -->
  <!-- <label class="pictureError"  *ngIf="pictureIsWrongFormat">{{ 'VENUES.PICTURE_IS_WRONG_FORMAT' | translate  }}</label> -->
</div>
